import { ITransportador } from "../Transportador";
import { LoggerConfiguracionToken, LogTipos } from "../Utilidades";
import { HttpClient } from "@angular/common/http";
import { LoggerConfiguracion } from "../LoggerConfiguracion";
import { environment } from "../../../../../environments/environment";
import { Inject } from "@angular/core";
import { PayloadError } from "../PayloadError";
import { firstValueFrom } from "rxjs";

export const SlackTransportadorFactory = (httpClient: HttpClient, loggerConfiguracion: LoggerConfiguracion) =>
    new SlackTransportador(httpClient, loggerConfiguracion);

class SlackTransportador implements ITransportador {

    private readonly APIURL = "https://slack.com/api/chat.postMessage";

    constructor(private httpClient: HttpClient,
        @Inject(LoggerConfiguracionToken) private loggerConfiguracion: LoggerConfiguracion) { }

    escribir(payload: PayloadError, tipo: LogTipos): void {
        if (payload.mensaje.includes("localhost:") || payload.mensaje.includes("Timeout")) {
            return;
        }

        if (tipo === LogTipos.DEBUG) {
            this.enviarMensajeSlack(`Debug: ${payload.mensaje}`);
        }

        if (tipo === LogTipos.ERROR) {
            this.enviarMensajeSlack(`Error: ${payload.mensaje}`);
        }

        if (tipo === LogTipos.INFO) {
            this.enviarMensajeSlack(`Info: ${payload.mensaje}`);
        }

        if (tipo === LogTipos.WARNING) {
            this.enviarMensajeSlack(`Warning: ${payload.mensaje}`);
        }
    }

    private enviarMensajeSlack(mensaje: string) {
        if (!environment.production || this.loggerConfiguracion.transportadores.slack == null) {
            return;
        }

        firstValueFrom(
            this.httpClient.post(this.APIURL,
                this.generarBodySlackMensaje(mensaje), {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                })
        ).finally(() => console.log("Error enviado a slack"));
    }

    private generarBodySlackMensaje(mensaje: string): string {
        const parametros = {
            token: this.loggerConfiguracion.transportadores.slack?.token,
            channel: this.loggerConfiguracion.transportadores.slack?.idCanal,
            text: mensaje
        };
        return Object.keys(parametros).map(clave => `${clave}=${parametros[clave]}`).join("&");
    }
}
